module.exports = __webpack_public_path__ + "media/images/steps_inactive_right_flat-386517ad1a0e1b9d0469049f6fbf26e1.png";